<section [ngClass.gt-xs]="'welcome'" [ngClass.xs]="'welcome mobile'">
  <div *ngIf="(pageProperties$ | async)!.isHomePage">
    <h1 id="main-title">Open an account in just a few minutes</h1>
    <mat-card [ngClass.gt-xs]="'welcome-cards'" [ngClass.xs]="'welcome-cards mobile'">
      <div>
        <div id="card-title">Here is what you will need to apply:</div>
        <div class="info-container" fxHide.xs fxLayout="row" fxLayoutAlign="center center" fxLayoutGap.gt-md="110px" fxLayoutGap="60px">
          <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" role="group" aria-label="simple">
            <div class="img-wrapper">
              <img class="img" src="/assets/images/tcb/ssn.svg" alt="Keeping it simple">
            </div>
            <mat-label class="title">Social Security Number</mat-label>
            <p class="info">To apply online, you must be 18+. All applicants must provide SSN.</p>
          </div>
          <div fxLayout="column" fxLayoutAlign="center center" fxLayout.sm="column" fxLayoutGap="5px" role="group" aria-label="smart">
            <div class="img-wrapper">
              <img class="img" src="/assets/images/tcb/id.svg" alt="Keeping it smart">
            </div>
            <mat-label class="title">U.S. Government Issued ID</mat-label>
            <p class="info">You’ll need a valid driver’s license or state issued ID for verification.</p>
          </div>
          <div fxLayout="column" fxLayoutAlign="center center" fxLayout.sm="column" fxLayoutGap="5px" role="group" aria-label="secure">
            <div class="img-wrapper">
              <img class="img" src="/assets/images/tcb/mobile.svg" alt="Keeping it secure">
            </div>
            <mat-label class="title">Mobile Device</mat-label>
            <p class="info">We require ID capture verification to apply online.</p>
          </div>
        </div>
        <mat-carousel
          fxShow.xs fxHide.gt-xs
          timings="250ms ease-in"
          [autoplay]="true"
          slideHeight="300px"
          [loop]="true"
          [hideArrows]="true"
          [hideIndicators]="false"
          [useKeyboard]="true"
          [useMouseWheel]="false"
          orientation="ltr"
          class="mat-carousel"
        >
          <mat-carousel-slide>
            <div class="info-container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px" role="group" aria-label="simple">
              <div class="img-wrapper">
                <img class="img" src="/assets/images/tcb/ssn.svg" alt="Keeping it simple">
              </div>
              <mat-label class="title">Social Security Number</mat-label>
              <p class="info">To apply online, you must be 18+. All applicants must provide SSN.</p>
            </div>
          </mat-carousel-slide>
          <mat-carousel-slide>
            <div class="info-container" fxLayout="column" fxLayoutAlign="center center" fxLayout.sm="column" fxLayoutGap="0px" role="group" aria-label="smart">
              <div class="img-wrapper">
                <img class="img" src="/assets/images/tcb/id.svg" alt="Keeping it smart">
              </div>
              <mat-label class="title">U.S. Government Issued ID</mat-label>
              <p class="info">You’ll need a valid driver’s license or state issued ID for verification.</p>
            </div>
          </mat-carousel-slide>
          <mat-carousel-slide>
            <div class="info-container" fxLayout="column" fxLayoutAlign="center center" fxLayout.sm="column" fxLayoutGap="0px" role="group" aria-label="secure">
              <div class="img-wrapper">
                <img class="img" src="/assets/images/tcb/mobile.svg" alt="Keeping it secure">
              </div>
              <mat-label class="title">Mobile Device</mat-label>
              <p class="info">We require ID capture verification to apply online.</p>
            </div>
          </mat-carousel-slide>
        </mat-carousel>
      </div>
    </mat-card>
  </div>
  <div id="page-title">
    <h1>
      {{ (pageProperties$ | async)!.title }}
    </h1>
  </div>
  <div *ngIf="(pageProperties$ | async)!.isHomePage" class="welcome-arrow centered-content">
    <button (click)="startApplication()">
      <img src="/assets/images/tcb/arrow.svg" alt="Start your application arrow">
    </button>
  </div>
</section>
